import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomCanonicalAliasMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomCanonicalAliasMessage = ({ message, className = '' }: RoomCanonicalAliasMessageProps) => {
  const sender = message.sender;
  const alias = message.content.canonical_alias;
  return (
    <div className={`room-canonical-alias-message ${className}`} style={{ color: '#0097a7', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间主别名为「${alias}」` : `房间主别名被修改为「${alias}」`}
    </div>
  );
}; 